import styles from "./ToggleButton.module.css";

interface ToggleButtonProps {
  label: string;
  value: string;
  active: boolean;
  onClick: (value: string) => void;
  type?: "radio" | "checkbox";
  variant?: "default" | "product";
}

export default function ToggleButton({
  label,
  value,
  active,
  onClick,
  type = "radio",
  variant = "default",
}: ToggleButtonProps) {
  return (
    <button
      type="button"
      role={type === "radio" ? "radio" : "checkbox"}
      aria-checked={active}
      className={`${styles.toggle} ${active ? styles.active : ""} ${
        variant === "product" ? styles.product : ""
      }`}
      onClick={() => onClick(value)}
    >
      {label}
    </button>
  );
}
